// 요금제 — 지금 요금제 · 사진 저장 용량·이번 달 알림톡 막대 · 진행 중 현장 수와 한도 · 요금제 목록(가격 없음) · 경고는 막지 않는다.

import Banner from "@buildpy/ui/banner";
import SectionCard from "@buildpy/ui/section-card";
import { formatNumber } from "@buildpy/core/lib/format";
import type { PlanPanel } from "@buildpy/core/modules/plan/usage-limit";
import { PLAN_LABEL } from "@buildpy/core/modules/plan/types";
import { Link } from "@/lib/nav";
import { PLAN_INTEREST_PATH } from "@/modules/plan/copy";
import { SettingsPlanList } from "@/modules/plan/ui/plan-cards";
import UsageMeterRow from "@/modules/plan/ui/usage-meter";
import { notifyAmountOf, storageAmountOf } from "@/modules/plan/ui/usage-meter-state";
import { PLAN_INTEREST_LINK_LABEL } from "./settings-plan-state";

interface Props {
  panel: PlanPanel;
}

const SettingsPlan = ({ panel }: Props) => (
  <SectionCard
    className="scroll-mt-4"
    data-testid="settings-plan"
    description="기능 전부 · 현장·고객·견적·계약·멤버 수 제한 없음. 사진 저장 용량과 알림톡 건수만 한도가 있습니다."
    id="plan"
    title="요금제">
    <dl className="grid gap-2 text-sm sm:grid-cols-3">
      <div>
        <dt className="text-muted-foreground">지금 요금제</dt>
        <dd className="font-semibold" data-testid="settings-plan-name">{PLAN_LABEL[panel.plan]}</dd>
      </div>
      <div>
        <dt className="text-muted-foreground">진행 중 현장</dt>
        <dd className="tabular-nums" data-testid="settings-plan-sites">
          {formatNumber(panel.activeSites)}곳 / {panel.limit === null ? "제한 없음" : `${formatNumber(panel.limit)}곳`}
        </dd>
      </div>
      <div>
        <dt className="text-muted-foreground">이번 달 고객 알림</dt>
        <dd className="tabular-nums" data-testid="settings-plan-notify">
          발송 {formatNumber(panel.notify.sent)}건 · 기록만 {formatNumber(panel.notify.logOnly)}건
        </dd>
      </div>
    </dl>
    {panel.warning && (
      <Banner className="mt-3" tone="warning">
        {panel.warning}
      </Banner>
    )}
    <div className="mt-4 flex flex-col gap-4">
      <UsageMeterRow amount={storageAmountOf(panel.usage.storage)} label="사진 저장 용량" meter={panel.usage.storage} testId="settings-plan-storage-meter" />
      <UsageMeterRow
        amount={notifyAmountOf(panel.usage.notify)}
        label="알림톡 · 이번 달"
        meter={panel.usage.notify}
        note="실제로 나간 알림톡만 셉니다(기록만은 빼고)."
        testId="settings-plan-notify-meter"
      />
    </div>
    <div className="mt-4 flex flex-col gap-2">
      <SettingsPlanList current={panel.plan} />
      <Link
        className="inline-flex min-h-11 items-center self-start text-sm font-medium text-primary underline underline-offset-4 hover:text-foreground"
        data-testid="settings-plan-interest"
        href={PLAN_INTEREST_PATH}>
        {PLAN_INTEREST_LINK_LABEL}
      </Link>
    </div>
  </SectionCard>
);

export default SettingsPlan;
